import { GalleryPrivacy } from "./GalleryPrivacy"
import ResourceLink from "../common/ResourceLink"
import ImageAsset from "../common/ImageAsset"

export class LegacyGallerySaveParams {
  galleryCode: string
  title?: string
  hashtag?: string
  topImageFile?: File | null
  bottomImageFile?: File | null

  constructor(galleryCode: string) {
    this.galleryCode = galleryCode
  }

  toFormData(): FormData {
    const data = new FormData()
    data.append("edit_gallery_id", this.galleryCode)

    if (this.title) data.append("title", this.title)
    if (this.hashtag) data.append("hash_tag", this.hashtag)
    if (this.topImageFile) data.append("top_image", this.topImageFile)
    if (this.bottomImageFile) data.append("bottom_image", this.bottomImageFile)

    return data
  }
}